(function () {
    "use strict";

    /**
     *
     * @constructor
     */
    function Url() {

    }

    /**
     * Removes query strings and hashes from a url
     * @param url
     * @returns {*}
     */
    Url.prototype.removeQueryStringAndHash = function (url) {
        function removeQueryString(url) {
            return url.split('?')[0];
        }

        function removeHash(url) {
            return url.split('#')[0];
        }

        return removeHash(removeQueryString(url));
    };


    /**
     * @param url
     * @returns {string}
     */
    Url.prototype.removeProtocol = function (url) {
        return url.substr(url.indexOf('://') + 3);
    };

    /**
     * Removes .html from the end of urls
     * @param url
     * @returns {*}
     */
    Url.prototype.removeHtml = function (url) {
        var indexOfHtml = url.indexOf('.html');
        return indexOfHtml > -1 ? url.slice(0, indexOfHtml) : url;
    };

    /**
     *
     * @param url
     * @returns {string|XML|void}
     */
    Url.prototype.replaceSlashesWithColon = function (url) {
        //replace "/" with ":";
        var formattedUrl = url.replace(/\//g, ':');
        if (url[url.length - 1] === '/') {
            formattedUrl = formattedUrl.slice(0, url.length - 1);
        }
        return formattedUrl;

    };

    /**
     * @param url
     * @returns {string|XML}
     */
    Url.prototype.replaceHyphensWithSpace = function (url) {
        var cleanUrl = url.replace(/-/g, ' ');
        return cleanUrl.replace('  ', ' ');
    };

    /**
     * @param cleanUrl
     * @returns {boolean}
     */
    Url.prototype.isHomepage = function (cleanUrl) {
        return cleanUrl === '';
    };

    /**
     * @param pageName
     * @returns {boolean}
     */
    Url.prototype.isErrorPage = function (pageName) {
        return pageName.indexOf('404') > -1;
    };

    /**
     * Doesn't need to be public but made so for testing
     * @param params
     * @param parameter
     * @returns {*}
     */
    Url.prototype.getFirstMatchingParameter = function (params, parameter) {
        for (var i = 0; i < params.length; i++) {
            var pair = params[i].split("=");
            if (pair[0] === parameter) {
                return pair[1];
            }
        }
        return (false);
    };

    /**
     * Retrieves the value of a query string parameter from the url
     * @param parameter
     * @param mockWindow
     * @returns {*}
     */
    Url.prototype.getQueryStringParameter = function (parameter, mockWindow) {
        //taken from http://css-tricks.com/snippets/javascript/get-url-variables/
        var windowObject = mockWindow || window;
        var queryString = windowObject.location.search.substring(1);
        var params = queryString.split("&");

        return this.getFirstMatchingParameter(params, parameter);
    };


    /**
     * Standardises urls
     * @param path
     */
    Url.prototype.cleanPathForReporting = function (path) {
        var cleanPath = this.removeQueryStringAndHash(path);
        cleanPath = this.replaceSlashesWithColon(cleanPath);
        cleanPath = this.replaceHyphensWithSpace(cleanPath);
        cleanPath = this.removeHtml(cleanPath);
        return cleanPath;
    };

    /**
     * Gets the current url
     * @param mockWindow
     */
    Url.prototype.getCurrentUrl = function (mockWindow) {
        var windowObject = mockWindow || window;
        return windowObject.location.href;
    };

    window.nadex = window.nadex || {};
    window.nadex.marketing = window.nadex.marketing || {};
    window.nadex.marketing.analytics = window.nadex.marketing.analytics || {};
    window.nadex.marketing.analytics.url = new Url();

}());